import { Copy, Share2, ExternalLink } from "lucide-react";
import { toast } from "sonner";
import { buildShareUrl } from "../lib/apiClient";

/**
 * Compact share actions used on dashboard rows/cards and after inquiry creation.
 * Keeps everything inline — no navigation required to share a link.
 */
export default function QuickShare({
  token,
  from_city,
  to_city,
  weight,
  weight_unit,
  material,
  size = "sm",
  testIdPrefix = "quick-share",
}) {
  const url = buildShareUrl(token);
  const h = size === "md" ? "h-10" : "h-8";
  const px = size === "md" ? "px-3" : "px-2.5";
  const text = size === "md" ? "text-sm" : "text-xs";

  const copy = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Link copied");
    } catch {
      toast.error("Copy failed");
    }
  };

  const whatsapp = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const msg = encodeURIComponent(
      `Transport quote request: ${from_city} → ${to_city}, ${weight} ${weight_unit} of ${material}. Submit your quote here: ${url}`
    );
    window.open(`https://wa.me/?text=${msg}`, "_blank");
  };

  const preview = (e) => {
    e.preventDefault();
    e.stopPropagation();
    window.open(url, "_blank");
  };

  return (
    <div className="inline-flex items-center gap-1" onClick={(e) => e.stopPropagation()}>
      <button
        type="button"
        data-testid={`${testIdPrefix}-copy`}
        onClick={copy}
        className={`${h} ${px} ${text} inline-flex items-center gap-1.5 border border-zinc-300 text-zinc-700 hover:bg-zinc-100 hover:text-zinc-900 font-medium`}
      >
        <Copy className="h-3.5 w-3.5" />
        Copy
      </button>
      <button
        type="button"
        data-testid={`${testIdPrefix}-whatsapp`}
        onClick={whatsapp}
        className={`${h} ${px} ${text} inline-flex items-center gap-1.5 border border-zinc-300 text-zinc-700 hover:bg-zinc-100 hover:text-zinc-900 font-medium`}
      >
        <Share2 className="h-3.5 w-3.5" />
        WhatsApp
      </button>
      <button
        type="button"
        data-testid={`${testIdPrefix}-preview`}
        onClick={preview}
        className={`${h} ${px} ${text} inline-flex items-center gap-1.5 border border-zinc-300 text-zinc-700 hover:bg-zinc-100 hover:text-zinc-900 font-medium`}
      >
        <ExternalLink className="h-3.5 w-3.5" />
        Preview
      </button>
    </div>
  );
}
